import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
import ResetPassword from "./Pages/Auth/ResetPassword";
import Default from "./Pages/Default";
import History from "./Pages/History";
import DeleteAccount from "./Pages/DeleteAccount";
import PrivatePolicy from "./Pages/privatePolicy";
import ManageInstitutes from "./Pages/ManageInstitutes";
import ManageDiscountCodes from "./Pages/ManageDiscountCodes";
import { Spin } from "antd";
import LoaderProvider, { useLoaderProvider } from "./context/LoaderProvider";
import NotificationProvider from "./context/NotificationProvider";

const Routing = () => {
  const { loader } = useLoaderProvider();

  return (
    <>
      <Router>
        <Routes>
          {/* auth Route */}
          <Route path="/n146m149" element={<Login />} />
          <Route path="/:token" element={<History />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/private-policy" element={<PrivatePolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/*" element={<Default />} />
        </Routes>
      </Router>
,
      {loader ? <Spin fullscreen size="large" className="z-[999999]" /> : null}
    </>
  );
};

const App = () => {
  return (
    <LoaderProvider>
      <NotificationProvider>
        <Routing />
      </NotificationProvider>
    </LoaderProvider>
  );
};
export default App;
